import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_generation_output_image_preview_set } from '@/state/ui/generation/LOCAL__ui_generation_output_image_preview_set';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { ENUM__page_generation_layout } from '../_enums/ENUM__page_generation_layout';

interface PROPS {
  children?: React.ReactNode;
  image_asset: DTO__image_asset;
}

export function G_WRAPPER_IMAGE__preview_on_layout_output({ children, image_asset }: PROPS) {
  const dispatch = use_dispatch();

  const { g_general__layout, global__page_type } = use_slice_ui(['g_general__layout', 'global__page_type']);

  /*
   *
   */
  use_effect(() => {
    return () => onMouseLeave();
  }, []);

  /*
   *
   */
  function onMouseOver() {
    dispatch(LOCAL__ui_generation_output_image_preview_set(image_asset));
  }

  function onMouseLeave() {
    dispatch(LOCAL__ui_generation_output_image_preview_set(DTO__image_asset.CREATE_STUB()));
  }

  /*
   *
   */
  if (image_asset.is_stub()) return children;
  if (global__page_type != ENUM__page_type.GENERATION) return children;
  if (g_general__layout != ENUM__page_generation_layout.OUTPUTS) return children;

  return (
    <div className="contents" {...{ onMouseOver, onMouseLeave }}>
      {children}
    </div>
  );
}
